import { Component } from '@angular/core';
@Component({
	templateUrl: './contrato.component.html',
})

export class ContratoComponent{
}